export default __webpack_public_path__ + "static/media/learn_bg_bottom.d42b79b2.png";